'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _switch = require('antd/lib/switch');

var _switch2 = _interopRequireDefault(_switch);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bool = function Bool(_ref) {
    var checkbox = _ref.checkbox,
        props = (0, _objectWithoutProperties3.default)(_ref, ['checkbox']);
    return (0, _wrapField2.default)(props, _react2.default.createElement(checkbox ? _checkbox2.default : _switch2.default, (0, _extends3.default)({
        checked: props.value,
        disabled: props.disabled,
        id: props.id,
        name: props.name,
        onChange: function onChange() {
            return props.onChange(!props.value);
        },
        ref: props.inputRef
    }, (0, _filterDOMProps2.default)(props))));
};

Bool.defaultProps = {
    checkbox: false,
    checkedChildren: _react2.default.createElement(_icon2.default, { type: 'check' }),
    unCheckedChildren: _react2.default.createElement(_icon2.default, { type: 'cross' })
};

exports.default = (0, _connectField2.default)(Bool, { ensureValue: false });


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/BoolField.js
// module id = 284
// module chunks = 35783957827783 65974612472484